import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import JsxComponent from '../core/jsxComponent';
import '../../scss/components/label.scss';
/** The name of the module */
const name = 'Label';
/** Class names for the label */
var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-label";
    ClassNames["JavaScript"] = "js-label";
})(ClassNames || (ClassNames = {}));
/** Class modifiers */
export var Modifiers;
(function (Modifiers) {
    Modifiers["DealCard"] = "dealCard";
    Modifiers["New"] = "new";
    Modifiers["ForYou"] = "forYou";
    Modifiers["Personalized"] = "personalized";
    Modifiers["Expired"] = "expired";
    Modifiers["Promoted"] = "promoted";
    Modifiers["Frontpage"] = "frontpage";
    Modifiers["Popular"] = "popular";
})(Modifiers || (Modifiers = {}));
/** TS for the label component */
class Label extends JsxComponent {
    constructor() {
        super(name);
    }
    /**
     * Creates a label element
     *
     * @param {Props} props Properties to populate Label with
     */
    // eslint-disable-next-line class-methods-use-this
    createElement(props) {
        let classNames = [ClassNames.Default, ClassNames.JavaScript];
        if (props?.classNames) {
            classNames = [...classNames, ...props.classNames];
        }
        if (props?.modifiers) {
            props.modifiers.forEach(modifier => classNames.push(classNameWithModifier(ClassNames.Default, modifier)));
        }
        return (JsxComponent.parseJsx("span", { className: classNames.join(' ') }));
    }
}
export default Label;
